export default __webpack_public_path__ + "static/media/Pretendard-Bold.0676c883.woff2";